<template>
    <div class="container-financebill" v-loading="loading">
       <h1>账单管理</h1>
       <div class="tabcontainer">
            <span class="download_save" @click="downloadSaveVisible = true">下载存储区</span>
            <el-tabs v-model="activeName" @tab-click="tabChange">
                <el-tab-pane label="资金账单" name="detailExportBill">
                    <div class="contentPayment" style="margin-bottom: 20px;">
                        <div>
                            <div class="middle">
                                支付服务：
                            </div>
                        </div>
                        <div>
                            <el-select
                                filterable
                                remote
                                @focus="handleFocusAppid"
                                :remote-method="handleSearchAppid"
                                v-model="detailExportBill.appId"
                            >
                                <el-option
                                    v-for="item in appidList"
                                    :key="item.appId"
                                    :value="item.appId"
                                    :label="item.appName"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="middle">
                            输入appid或服务名称可进行搜索
                        </div>
                    </div>
                    <div class="contentPayment">
                      <div>
                          <div class="middle">
                              渠道账户：
                          </div>
                      </div>
                      <el-select v-model="detailExportBill.channelType">
                        <el-option
                            :value="0"
                          label="全部"
                        ></el-option>
                        <el-option
                          :value="1"
                          label="百信"
                        ></el-option>
                        <el-option
                          :value="2"
                          label="微信"
                        ></el-option>
                        <el-option
                          v-if="[11, 12, 13, 14].includes(detailAppScene)"
                          :value="4"
                          label="渠道线下结算（含华为IAP支付等）"
                        ></el-option>
                        <el-option
                          :value="5"
                          label="百信垫资账户"
                        ></el-option>
                      </el-select>
                    </div>
                    <!-- <el-row>
                        <el-col :span="2">
                            <div class="middle">
                                日期类型：
                            </div>
                        </el-col>
                        <el-col :span="20">
                            <div class="middle">
                                <el-radio-group v-model="detailExportBill.timeType">
                                    <el-radio :label="1">
                                        发生日期
                                        <pop content="订单核销、退款或商户结算状态发生变更的时间"></pop>
                                    </el-radio>
                                    <el-radio :label="2">
                                        账务处理日期
                                        <pop content="订单交易或商户结算传到资金池账务开始处理的时间 "></pop>
                                    </el-radio>
                                </el-radio-group>
                            </div>
                        </el-col>
                    </el-row> -->
          <el-row>
            <el-col :span="2">
              <div class="middle">
                <span>交易日期：</span>
                <pop
                  content="订单核销、退款等订单状态或结算状态发生变更的时间"
                ></pop>
              </div>
            </el-col>
            <el-col :span="20">
              <el-date-picker type="daterange" v-model="detailExportBill.time">
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <div>
                <img src="../../img/bulb.png" alt="" class="bulb" />
                <span>
                  资金账单为账户每次余额变动时，所产生的流水明细对账单。</span
                >
                <p class="warn-note">
                    说明：资金账单中，无法查询微信渠道技术服务费数据，如需查看微信渠道技术服务费数据，
                    可在交易账单及技术服务费账单中进行查询
                </p>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2">
              <el-button type="primary" @click="handleDetailExport"
                >账单下载</el-button
              >
            </el-col>
            <el-col :span="2">
              <el-button type="primary" @click="handleDetailSearch"
                >查询</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-table
              :data="tableData1"
              border
              style="width: 100%">
              <el-table-column
                  prop="date"
                  label="日期"
                  width="160">
              </el-table-column>
              <el-table-column
                  prop="channelDesc"
                  label="渠道账户"
                  width="160">
              </el-table-column>
              <el-table-column
                  prop="startBalance"
                  label="资金池期初余额(元)"
                  width="160">
              </el-table-column>
              <el-table-column
                  prop="income"
                  label="收入金额(元)"
                  width="160">
              </el-table-column>
              <el-table-column
                  prop="incomeCount"
                  label="收入笔数"
                  width="160">
              </el-table-column>
              <el-table-column
                  prop="expense"
                  label="支出金额(元)"
                  width="160">
              </el-table-column>
              <el-table-column
                  prop="expenseCount"
                  label="支出笔数"
                  width="160">
              </el-table-column>
              <el-table-column
                  prop="technology"
                  label="技术服务费金额"
                  width="160">
              </el-table-column>
              <el-table-column
                  prop="technologyCount"
                  label="技术服务费笔数"
                  width="160">
              </el-table-column>
              <el-table-column
                  prop="adjust"
                  label="调整款金额(元)"
                  width="160">
              </el-table-column>
              <el-table-column
                  prop="adjustCount"
                  label="调整金额笔数"
                  width="160">
              </el-table-column>
              <el-table-column
                  prop="endBalance"
                  label="资金池日终余额(元)"
                  width="160">
              </el-table-column>
            </el-table>
            <div class="pagation-wrapper">
              <span class="pagation-text">共{{pageParam1.totalPage}}页/共{{pageParam1.totalCount}}条</span>
              <el-pagination layout="prev, pager, next"
                  :total="pageParam1.totalCount"
                  :page-size="pageParam1.pageSize"
                  :current-page.sync="pageParam1.currentPage"
                  @current-change="handleDetailSearch"></el-pagination>
            </div>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="交易账单" name="incomeExportBill">
          <div class="contentPayment" style="margin-bottom: 20px;">
            <div>
              <div class="middle">支付服务：&emsp;&ensp;</div>
            </div>
            <div>
              <el-select
                filterable
                remote
                @focus="handleFocusAppid"
                :remote-method="handleSearchAppid"
                v-model="incomeExportBill.appId"
                @change="change($event, incomeExportBill)"
              >
                <el-option
                  v-for="item in appidList"
                  :key="item.appId"
                  :value="item.appId"
                  :label="item.appName"
                >
                </el-option>
              </el-select>
              <el-select
                v-show="incomeExportBill.flag"
                filterable
                remote
                @focus="handleFocusplitid"
                :remote-method="handleSearchsplitid"
                v-model="incomeExportBill.splitId"
              >
                <el-option
                  v-for="item in splitList"
                  :key="item.splitId"
                  :value="item.splitId"
                  :label="item.splitName"
                >
                </el-option>
              </el-select>
            </div>
            <div class="middle" v-if="!incomeExportBill.splitId">
              输入appid或服务名称可进行搜索
            </div>
            <div class="middle" v-else>输入splitid或分账对象名称可进行搜索</div>
          </div>
          <div class="contentPayment">
            <div>
                <div class="middle">
                    渠道账户：
                </div>
            </div>
            <el-select v-model="incomeExportBill.channelType">
              <el-option
                  :value="0"
                label="全部"
              ></el-option>
              <el-option
                :value="1"
                label="百信"
              ></el-option>
              <el-option
                :value="2"
                label="微信"
              ></el-option>
              <el-option
                v-if="[11, 12, 13, 14].includes(incomeAppScene)"
                :value="4"
                label="渠道线下结算（含华为IAP支付等）"
              ></el-option>
            </el-select>
          </div>
          <el-row>
            <el-col :span="2">
              <div class="middle">账单类型：</div>
            </el-col>
            <el-col :span="20">
              <div class="middle">
                <el-radio-group v-model="incomeExportBill.billType">
                  <el-radio :label="1"> 全部交易账单 </el-radio>
                  <el-radio :label="2"> 支付账单 </el-radio>
                  <el-radio :label="3"> 退款账单 </el-radio>
                </el-radio-group>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2">
              <div class="middle">交易日期：</div>
            </el-col>
            <el-col :span="20">
              <el-date-picker type="daterange" v-model="incomeExportBill.time">
              </el-date-picker>
            </el-col>
          </el-row>
          <img src="../../img/bulb.png" alt="" class="bulb" />
          <span>交易账单为每笔订单状态变化对账户余额产生影响时，所产生的交易明细对账单，即所有“已消费”和“退款成功”状态的订单明细记录。 </span>
          <el-row>
            <el-col :span="2">
              <el-button type="primary" @click="handleIncomeExport"
                >账单下载</el-button
              >
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="技术服务费账单" name="technologyBill">
          <div class="contentPayment" style="margin-bottom: 20px;">
            <div>
              <div class="middle">支付服务：&emsp;&ensp;</div>
            </div>
            <div>
              <el-select
                filterable
                remote
                @focus="handleFocusAppid"
                :remote-method="handleSearchAppid"
                v-model="technologyBill.appId"
                @change="change($event, technologyBill)"
              >
                <el-option
                  v-for="item in appidList"
                  :key="item.appId"
                  :value="item.appId"
                  :label="item.appName"
                >
                </el-option>
              </el-select>
              <el-select
                v-show="technologyBill.flag"
                filterable
                remote
                @focus="handleFocusplitid"
                :remote-method="handleSearchsplitid"
                v-model="technologyBill.splitId"
              >
                <el-option
                  v-for="item in splitList"
                  :key="item.splitId"
                  :value="item.splitId"
                  :label="item.splitName"
                >
                </el-option>
              </el-select>
            </div>
            <div class="middle" v-if="!technologyBill.splitId">
              输入appid或服务名称可进行搜索
            </div>
            <div class="middle" v-else>输入splitid或分账对象名称可进行搜索</div>
          </div>
          <div class="contentPayment">
            <div>
                <div class="middle">
                    渠道账户：
                </div>
            </div>
            <el-select v-model="technologyBill.channelType">
              <el-option
                  :value="0"
                label="全部"
              ></el-option>
              <el-option
                :value="1"
                label="百信"
              ></el-option>
              <el-option
                :value="2"
                label="微信"
              ></el-option>
            </el-select>
          </div>
          <el-row>
            <el-col :span="2">
              <div class="middle">交易日期：</div>
            </el-col>
            <el-col :span="20">
              <el-date-picker type="daterange" v-model="technologyBill.time">
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <div>
                <img src="../../img/bulb.png" alt="" class="bulb" />
                <span>
                  技术服务费账单为每笔交易产生技术服务费扣取时，所产生的所有技术服务费明细记录对账单。</span
                >
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2">
              <el-button type="primary" @click="handletechnology"
                >账单下载</el-button
              >
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="结算账单" name="payExportBill">
          <div class="contentPayment" style="margin-bottom: 20px;">
            <div>
              <div class="middle">支付服务：&emsp;&ensp;</div>
            </div>
            <div>
              <el-select
                filterable
                remote
                @focus="handleFocusAppid"
                :remote-method="handleSearchAppid"
                v-model="payExportBill.appId"
                @change="change($event, payExportBill)"
              >
                <el-option
                  v-for="item in appidList"
                  :key="item.appId"
                  :value="item.appId"
                  :label="item.appName"
                >
                </el-option>
              </el-select>
              <el-select
                v-show="payExportBill.flag"
                filterable
                remote
                @focus="handleFocusplitid"
                :remote-method="handleSearchsplitid"
                v-model="payExportBill.splitId"
              >
                <el-option
                  v-for="item in splitList"
                  :key="item.splitId"
                  :value="item.splitId"
                  :label="item.splitName"
                >
                </el-option>
              </el-select>
            </div>
            <div class="middle" v-if="!payExportBill.splitId">
              输入appid或服务名称可进行搜索
            </div>
            <div class="middle" v-else>输入splitid或分账对象名称可进行搜索</div>
          </div>
          <div class="contentPayment">
            <div>
                <div class="middle">
                    渠道账户：
                </div>
            </div>
            <el-select v-model="payExportBill.channelType">
              <el-option
                  :value="0"
                label="全部"
              ></el-option>
              <el-option
                :value="1"
                label="百信"
              ></el-option>
              <el-option
                :value="2"
                label="微信"
              ></el-option>
            </el-select>
          </div>
          <el-row>
            <el-col :span="2">
              <div class="middle">结算日期：</div>
            </el-col>
            <el-col :span="20">
              <el-date-picker type="daterange" v-model="payExportBill.time">
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <div>
                <img src="../../img/bulb.png" alt="" class="bulb" />
                <span>
                  结算账单为每次商户结算打款时，所产生的打款记录明细对账单。</span
                >
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2">
              <el-button type="primary" @click="handlePayExport"
                >账单下载</el-button
              >
            </el-col>
            <el-col :span="2">
              <el-button type="primary" @click="handlePaySearch(1)"
                >查询</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-table
              :data="tableData4"
              border
              style="width: 100%">
              <el-table-column
                  prop="date"
                  label="结算日期"
                  width="160">
              </el-table-column>
              <el-table-column
                  label="结算账期"
                  width="160">
                  <template slot-scope="scope">
                    <span>{{scope.row.startDate || 'null'}}至{{scope.row.endDate || 'null'}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="channelDesc"
                  label="渠道账户"
                  width="160">
              </el-table-column>
              <el-table-column
                  prop="settleMoney"
                  label="支付结算金额(元)"
                  width="160">
              </el-table-column>
              <el-table-column
                  prop="refundMoney"
                  label="退款结算金额(元)"
                  width="160">
              </el-table-column>
              <el-table-column
                  prop="technologyFees"
                  label="手续费(元)"
                  width="160">
              </el-table-column>
              <el-table-column
                  prop="adjustMoney"
                  label="调整款金额(元)"
                  width="160">
              </el-table-column>
              <el-table-column
                  prop="entryMoney"
                  label="入账金额(元)"
                  width="160">
              </el-table-column>
              <el-table-column
                  prop="payStatus"
                  label="自动提现状态"
                  width="160">
                  <template slot-scope="scope">
                    <span class="desc">{{scope.row.payStatus}}</span>
                    <el-tooltip placement="top">
                        <div v-if="scope.row.payDesc && scope.row.payDesc !== '-' " slot="content">
                            <pre>{{scope.row.payDesc}}</pre>
                        </div>
                        <span><i v-if="scope.row.payDesc && scope.row.payDesc !== '-' " class="el-icon-question"></i></span>
                    </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                  label="操作">
                <template slot-scope="scope">
                      <div>
                          <el-button
                              size="mini"
                              type="primary"
                              @click="goDownload(scope.row)">下载账单</el-button>
                      </div>
                  </template>
              </el-table-column>
            </el-table>
            <div class="pagation-wrapper">
              <span class="pagation-text">共{{pageParam4.totalPage}}页/共{{pageParam4.totalCount}}条</span>
              <el-pagination layout="prev, pager, next"
                  :total="pageParam4.totalCount"
                  :page-size="pageParam4.pageSize"
                  :current-page.sync="pageParam4.currentPage"
                  @current-change="handlePaySearch"></el-pagination>
            </div>
          </el-row>
          <el-row>
            <div>注：入账金额仅作为结算统计参考，实际收到的款项以提现金额为准。</div>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="先享后付账单" name="enjoyNowPayLaterBill">
            <el-row>
                <el-col :span="2">
                  <div class="middle">渠道账户：</div>
                </el-col>
                <el-select v-model="enjoyNowPayLaterBill.channelType">
                    <el-option
                        :value="0"
                        label="全部"
                    ></el-option>
                    <el-option
                        :value="1"
                        label="百信"
                    ></el-option>
                    <el-option
                        :value="2"
                        label="微信"
                    ></el-option>
                </el-select>
            </el-row>
            <el-row>
                <el-col :span="2">
                    <div class="middle">结算日期：</div>
                  </el-col>
                <el-col :span="20">
                  <el-date-picker type="daterange" v-model="enjoyNowPayLaterBill.time"></el-date-picker>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                  <div>
                      <img
                          class="bulb"
                          src="../../img/bulb.png"
                          alt=""
                      />
                      <span>
                          先享后付账单为仅订单发生垫资时的明细，订单未发生垫资的费用明细，在资金账单体现。
                      </span>
                  </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="2">
                    <el-button type="primary" @click="handleEnjoyNowPayLaterBillExport">
                        账单下载
                    </el-button>
                </el-col>
            </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 下载储存区提示 -->
    <div class="notify_container">
      <el-dialog
        width="50%"
        :visible.sync="notifyVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <div class="notify">
          <span>账单已开始下载，请在下载存储区中查看</span>
        </div>
      </el-dialog>
    </div>
    <!-- 下载储存区弹框 -->
    <el-dialog
      title="下载储存区"
      width="50%"
      :visible.sync="downloadSaveVisible"
    >
      <downloadSave
        v-if="downloadSaveVisible"
        :appId="this[activeName].appId"
        :splitId="this[activeName].splitId"
        :userid="userid"
        :active-name="activeName"
      ></downloadSave>
    </el-dialog>
  </div>
</template>
<script>
import pop from "../../components/pop";
import { getLastWeek } from "../../utils/utils";
import {
  requestAppidList,
  detailExport,
  incomeExport,
  payExport,
  getSplitList,
  endBalanceList,
  withdrawTask,
  enjoyNowPayLaterBillExport,
} from "../../api/apiMap/index.js";
import downloadSave from "../../components/downloadSave";
export default {
  components: {
    pop,
    downloadSave,
  },
  created() {
    this.getAppidList("", true);
  },
  data() {
    return {
      cheackedvalue: {
        value: "",
        all: "",
      },
      loading: false,
      notifyVisible: false,
      downloadSaveVisible: false,
      userid: '',
      splitList: [
        // {
        //   split_name: "11",
        //   splitName: "11",
        //   serviceType: 3,
        //   service_type: 3,
        //   split_id: 11,
        //   splitId: 11,
        // },
        // {
        //   split_name: "33",
        //   splitName: "33",
        //   serviceType: 1,
        //   service_type: 1,
        //   split_id: 10860,
        //   splitId: 10860,
        // },
        // {
        //   split_name: "77",
        //   splitName: "77",
        //   serviceType: 1,
        //   service_type: 1,
        //   split_id: 10868,
        //   splitId: 10868,
        // },
      ], //分账列表
      appidList: [
        // {
        //   app_name: "1",
        //   appName: "1",
        //   serviceType: 1,
        //   service_type: 1,
        //   appId: 10863,
        //   app_id: 10863,
        // },
        // {
        //   app_name: "2",
        //   appName: "2",
        //   serviceType: 3,
        //   service_type: 3,
        //   appId: 10862,
        //   app_id: 10862,
        // },
        // {
        //   app_name: "3",
        //   appName: "3",
        //   serviceType: 1,
        //   service_type: 1,
        //   appId: 10861,
        //   app_id: 10861,
        // },
      ],
      // 资金账单下table数据
      tableData1: [],
      pageParam1: {
        totalCount: 1,
        totalPage: 1,
        currentPage: 1,
        pageSize: 10,
      },
      // 结算账单下table数据
      tableData4: [],
      pageParam4: {
        totalCount: 1,
        totalPage: 1,
        currentPage: 1,
        pageSize: 10,
      },
      activeName: "detailExportBill",
      detailExportBill: {
        flag: false,
        type: 0,
        splitId: "",
        appId: "",
        timeType: 1,
        moneyType: -1,
        channelType: 0,
        time: getLastWeek(),
        startTime: "",
        endTime: "",
        name: "detailExportBill",
      },
      detailAppScene: 0,
      incomeExportBill: {
        flag: false,
        type: 0,
        splitId: "",
        appId: "",
        timeType: 1,
        billType: 1,
        channelType: 0,
        time: getLastWeek(),
        startTime: "",
        endTime: "",
        name: "incomeExportBill",
      },
      incomeAppScene: 0,
      payExportBill: {
        flag: false,
        type: 0,
        splitId: "",
        appId: "",
        timeType: 1,
        channelType: 0,
        time: getLastWeek(),
        startTime: "",
        endTime: "",
        name: "payExportBill",
      },
      technologyBill: {
        flag: false,
        type: 0,
        splitId: "",
        appId: "",
        timeType: 1,
        billType: 10,
        channelType: 0,
        time: getLastWeek(),
        startTime: "",
        endTime: "",
        name: "technologyBill",
      },
      enjoyNowPayLaterBill: {
        channelType: 0,
        time: getLastWeek()
      }
    };
  },
  watch: {
    // 当某个tab选择了appid以后,应该重新将appidList填满
    "detailExportBill.appId"(value, oldValue) {
      if (oldValue) {
        this.getAppidList("");
      }
      const selectedItem = this.appidList.find(item => item.appId === value);
      this.detailAppScene = selectedItem ? selectedItem.appScene : 0;
      this.detailExportBill.channelType = 0;
    },
    "incomeExportBill.appId"(value, oldValue) {
      if (oldValue) {
        this.getAppidList("");
      }
      const selectedItem = this.appidList.find(item => item.appId === value);
      this.incomeAppScene = selectedItem ? selectedItem.appScene : 0;
      this.incomeExportBill.channelType = 0;
    },
    "payExportBill.appId"(value, oldValue) {
      if (oldValue) {
        this.getAppidList("");
      }
    },
    "technologyBill.appId"(value, oldValue) {
      if (oldValue) {
        this.getAppidList("");
      }
    },
  },
  methods: {
    tabChange(tab) {
      this.activeName = tab.name;
    },
    // 获取焦点首先重新拉取一下
    handleFocusAppid() {
      this.getAppidList("", false);
    },
    // 输入appid进行搜索
    handleSearchAppid(appName) {
      this.getAppidList(appName, false);
    },
    handleFocusplitid() {
      this.usergetSplitList("");
    },
    // 输入splitid进行搜索
    handleSearchsplitid(splitName) {
      this.usergetSplitList(splitName);
    },
    // 获取appidlist, 第二个参数为标记第一次进入页面的时候，默认选中第一个appid
    getAppidList(appName = "", setAppid = false) {
      requestAppidList(appName)
        .then((result) => {
          if (result.errno === 0) {
            this.appidList = result.data;
            if (setAppid) {
              let appId =
                result.data && result.data[0] ? result.data[0].appId : "";
              this.detailExportBill.appId = appId;
              this.incomeExportBill.appId = appId;
              this.payExportBill.appId = appId;
              this.technologyBill.appId = appId;
              let appScene = 
                result.data && result.data[0] ? result.data[0].appScene : 0;
              this.detailAppScene = appScene;
              this.incomeAppScene = appScene;
            }
            this.userid = result.userinfo.userid || '';
          } else {
            this.$message.error(result.errmsg || result.msg || "");
          }
        })
        .catch(() => {
          this.$message.error("网络错误");
        });
    },
    // 打开账单下载的提示框,2秒后关闭
    openNotify() {
      if (!this.notifyVisible) {
        this.notifyVisible = true;
      }
      setTimeout(() => {
        this.notifyVisible = false;
      }, 2000);
    },
    // 点击资金账单下载
    handleDetailExport() {
      if (
        !this.detailExportBill.appId ||
        !this.detailExportBill.time ||
        !this.detailExportBill.time[0] ||
        !this.detailExportBill.time[1] ||
        !this.detailExportBill.timeType ||
        !this.detailExportBill.moneyType
      ) {
        this.$message.error("您所选的参数有误!");
        return;
      }
      let params = {
        type: this.detailExportBill.type,

        appId:
          this.detailExportBill.splitId == ""
            ? this.detailExportBill.appId
            : this.detailExportBill.splitId,
        timeType: this.detailExportBill.timeType,
        moneyType: this.detailExportBill.moneyType,
        channelType: this.detailExportBill.channelType,
        startTime: new Date(this.detailExportBill.time[0]).getTime() + "",
        endTime: new Date(this.detailExportBill.time[1]).getTime() + "",
      };
      this.loading = true;
      detailExport(params)
        .then((result) => {
          if (result.errno === 0) {
            this.openNotify();
            this.loading = false;
          } else {
            this.$message.error(result.errmsg || result.msg || "");
            this.loading = false;
          }
        })
        .catch(() => {
          this.$message.error("网络错误");
          this.loading = false;
        });
    },
    // 点击交易账单下载
    handleIncomeExport() {
      if (
        !this.incomeExportBill.appId ||
        !this.incomeExportBill.time ||
        !this.incomeExportBill.time[0] ||
        !this.incomeExportBill.time[1] ||
        !this.incomeExportBill.timeType ||
        !this.incomeExportBill.billType
      ) {
        this.$message.error("您所选的参数有误!");
        return;
      }
      let params = {
        type: this.incomeExportBill.type,
        appId:
          this.incomeExportBill.splitId == ""
            ? this.incomeExportBill.appId
            : this.incomeExportBill.splitId,
        timeType: this.incomeExportBill.timeType,
        billType: this.incomeExportBill.billType,
        channelType: this.incomeExportBill.channelType,
        startTime: new Date(this.incomeExportBill.time[0]).getTime() + "",
        endTime: new Date(this.incomeExportBill.time[1]).getTime() + "",
      };
      this.loading = true;
      incomeExport(params)
        .then((result) => {
          if (result.errno === 0) {
            this.openNotify();
            this.loading = false;
          } else {
            this.$message.error(result.errmsg || result.msg || "");
            this.loading = false;
          }
        })
        .catch(() => {
          this.$message.error("网络错误");
          this.loading = false;
        });
    },
    // 点击结算账单下载
    handlePayExport() {
      if (
        !this.payExportBill.appId ||
        !this.payExportBill.time ||
        !this.payExportBill.time[0] ||
        !this.payExportBill.time[1] ||
        !this.payExportBill.timeType
      ) {
        this.$message.error("您所选的参数有误!");
        return;
      }
      let params = {
        type: this.payExportBill.type,
        appId:
          this.payExportBill.splitId == ""
            ? this.payExportBill.appId
            : this.payExportBill.splitId,
        timeType: this.payExportBill.timeType,
        channelType: this.payExportBill.channelType,
        startTime: new Date(this.payExportBill.time[0]).getTime() + "",
        endTime: new Date(this.payExportBill.time[1]).getTime() + "",
      };
      this.loading = true;
      payExport(params)
        .then((result) => {
          if (result.errno === 0) {
            this.openNotify();
            this.loading = false;
          } else {
            this.$message.error(result.errmsg || result.msg || "");
            this.loading = false;
          }
        })
        .catch(() => {
          this.$message.error("网络错误");
          this.loading = false;
        });
    },
    // 点击资金账单查询
    handleDetailSearch() {
      // if (
      //   !this.detailExportBill.appId ||
      //   !this.detailExportBill.time ||
      //   !this.detailExportBill.time[0] ||
      //   !this.detailExportBill.time[1]
      // ) {
      //   this.$message.error("您所选的参数有误!");
      //   return;
      // }
      let params = {
        type: this.detailExportBill.type,
        appId:
          this.detailExportBill.splitId == ""
            ? this.detailExportBill.appId
            : this.detailExportBill.splitId,
        // appId:297003,
        channelType: this.detailExportBill.channelType,
        startTime: new Date(this.detailExportBill.time[0]).getTime() + "",
        endTime: new Date(this.detailExportBill.time[1]).getTime() + "",
        curPage: this.pageParam1.currentPage,
        pageSize: this.pageParam1.pageSize
      };
      this.loading = true;
      endBalanceList(params)
        .then((result) => {
          if (result.errno === 0) {
            this.tableData1 = result.data.data;
            this.pageParam1 = {
              totalCount: result.data.totalCount,
              totalPage: result.data.totalPage,
              currentPage: result.data.curPage,
              pageSize: result.data.pageSize,
            }
            this.loading = false;
          } else {
            this.$message.error(result.errmsg || result.msg || "");
            this.loading = false;
          }
        })
        .catch(() => {
          this.$message.error("网络错误");
          this.loading = false;
        });
    },
    // 点击结算账单查询
    handlePaySearch() {
      // if (
      //   !this.payExportBill.appId ||
      //   !this.payExportBill.time[0] ||
      //   !this.payExportBill.time[1]
      // ) {
      //   this.$message.error("您所选的参数有误!");
      //   return;
      // }
      let params = {
        type: this.payExportBill.type,
        appId:
          this.payExportBill.splitId == ""
            ? this.payExportBill.appId
            : this.payExportBill.splitId,
        // appId:297003,
        channelType: this.payExportBill.channelType,
        startTime: new Date(this.payExportBill.time[0]).getTime() + "",
        endTime: new Date(this.payExportBill.time[1]).getTime() + "",
        curPage: this.pageParam4.currentPage,
        pageSize: this.pageParam4.pageSize
      };
      this.loading = true;
      withdrawTask(params)
        .then((result) => {
          if (result.errno === 0) {
            this.loading = false;
            this.tableData4 = result.data.data;
            this.pageParam4 = {
              totalCount: result.data.totalCount,
              totalPage: result.data.totalPage,
              currentPage: result.data.curPage,
              pageSize: result.data.pageSize,
            }
          } else {
            this.$message.error(result.errmsg || result.msg || "");
            this.loading = false;
          }
        })
        .catch(() => {
          this.$message.error("网络错误");
          this.loading = false;
        });
    },
    goDownload(scope) {
      this.activeName = "incomeExportBill"
      this.incomeExportBill.time = [scope.startDate, scope.endDate];
      this.incomeExportBill.channelType = scope.channelType;
    },
    //技术服务费 导出
    handletechnology() {
      if (
        !this.technologyBill.appId ||
        !this.technologyBill.time ||
        !this.technologyBill.time[0] ||
        !this.technologyBill.time[1] ||
        !this.technologyBill.timeType ||
        !this.technologyBill.billType
      ) {
        this.$message.error("您所选的参数有误!");
        return;
      }
      let params = {
        type: this.technologyBill.type,
        appId:
          this.technologyBill.splitId == ""
            ? this.technologyBill.appId
            : this.technologyBill.splitId,
        timeType: this.technologyBill.timeType,
        billType: this.technologyBill.billType,
        channelType: this.technologyBill.channelType,
        startTime: new Date(this.technologyBill.time[0]).getTime() + "",
        endTime: new Date(this.technologyBill.time[1]).getTime() + "",
      };
      this.loading = true;
      incomeExport(params)
        .then((result) => {
          if (result.errno === 0) {
            this.openNotify();
            this.loading = false;
          } else {
            this.$message.error(result.errmsg || result.msg || "");
            this.loading = false;
          }
        })
        .catch(() => {
          this.$message.error("网络错误");
          this.loading = false;
        });
    },
    change(value, all) {
      all.splitId = "";
      all.type = 0;

      all.flag = false;
      this.appidList.forEach((item) => {
        if (item.appId === value && item.serviceType === 3) {
          all.type = 2;
          all.flag = true;
           this.cheackedvalue = {
        value: value,
        all: all,
      };
          getSplitList({ appId: value }).then((result) => {
            if (result.errno === 0) {
              this.splitList = result.data;
              all.splitId = this.splitList[0].splitId;
            } else {
              this.$message.error(result.errmsg || result.msg || "");
            }
          });
        }
      });
    },
    //二级导航输入搜索调用
    usergetSplitList(splitInfo) {
      getSplitList({ appId: this.cheackedvalue.value, splitInfo }).then(
        (result) => {
          if (result.errno === 0) {
            this.splitList = result.data;

            this.cheackedvalue.all.splitId = this.splitList[0].splitId;
          } else {
            this.$message.error(result.errmsg || result.msg || "");
          }
        }
      );
    },
    // 点击先享后付账单下载
    handleEnjoyNowPayLaterBillExport() {
        if (!this.enjoyNowPayLaterBill.time) {
            this.$message.error("您所选的参数有误!");
            return;
        }
        let params = {
            startTime: new Date(this.enjoyNowPayLaterBill.time[0]).getTime() + "",
            endTime: new Date(this.enjoyNowPayLaterBill.time[1]).getTime() + "",
            userid: this.userid,
            timestamp: new Date().getTime() + "",
            channelType: this.enjoyNowPayLaterBill.channelType,
        };
        this.loading = true;
        enjoyNowPayLaterBillExport(params).then(result => {
            if (result.errno === 0) {
              this.openNotify();
              this.loading = false;
            } else {
              this.$message.error(result.errmsg || result.msg || "");
              this.loading = false;
            }
        }).catch(() => {
            this.$message.error("网络错误");
            this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scope>
.container-financebill {
  h1 {
    font-size: 18px;
    margin-bottom: 15px;
  }
  .tabcontainer {
    position: relative;
    padding: 0 10px;
    .download_save {
      color: #1d98ff;
      cursor: pointer;
      position: absolute;
      right: 50px;
      top: 10px;
      z-index: 10;
    }
    .el-button,
    .el-select,
    .el-date-editor--daterange {
      transform: scale(96%);
      transform-origin: 0;
    }
    .el-row {
      margin: 30px 0;
    }
  }
  .middle {
    margin-left: 10px;
    line-height: 40px;
  }
  .notify_container {
    .el-dialog__header {
      padding: 0;
    }
    .notify {
      width: 100%;
      height: 100%;
      position: relative;
      & > span {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 16px;
      }
    }
  }
  .bulb {
    width: 20px;
    height: 20px;
    vertical-align: top;
  }
  .warn-note {
    color: red;
    margin: 10px 0 0 22px;
  }
  .pagation-wrapper {
    background: #ffffff;
    display: flex;
    align-items: center;
    float: right;
    margin: 20px;

    .pagation-text {
      margin-right: 10px;
      font-weight: 400;
      color: #606266;
    }
  }
}
.contentPayment {
  display: flex;
  & > div:nth-child(2) {
    width: auto;
    padding: 0;
    margin-right: -14px;
  }
}
</style>
